import React, { ChangeEvent, Component } from 'react';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { connectToContext, IAppContext } from 'contextStore';
import { stringifyRange } from 'utils/rangeHelpers';
import { Attributes, FormType, GetAttributesType } from './formField.interface';

interface IProps extends IAppContext {
  name: string;
  onChange: (name: string, value: string) => void;
  title: string;
  tooltip?: string;
  attributes?: Attributes;
  getAttributes?: GetAttributesType;
  valid: boolean;
  validationMessage: string;
  form?: FormType;
  testID?: string;
}

interface IState {
  value: {
    [key: string]: string;
    from: string;
    to: string;
  };
}

/**
 * @deprecated
 * @see library/NumberRange.tsx
 */
class NumberRange extends Component<IProps, IState> {
  state: IState = {
    value: {
      from: '',
      to: '',
    },
  };

  onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target;
    const { value } = this.state;

    value[name] = e.target.value;

    this.setState({ value });
    this.props.onChange(this.props.name, stringifyRange(value.from, value.to));
  };

  render() {
    const {
      name,
      title,
      tooltip,
      attributes,
      getAttributes,
      valid,
      validationMessage,
      form,
      testID = 'formNumberRange',
      i18next,
    } = this.props;
    const attr = getAttributes ? { ...attributes, ...getAttributes(form) } : attributes;
    const { from, to } = this.state.value;

    return (
      <InputFieldWrapper
        name={name}
        className="number-range"
        testID={testID}
        tooltip={tooltip}
        title={title}
        valid={valid}
        validationMessage={validationMessage}>
        <div className="number-range__fields">
          <input
            className={cn('form__input', { invalid: !valid })}
            type="number"
            name="from"
            onChange={this.onChange}
            value={from}
            {...attr}
            placeholder={i18next.t(keyMap.formsFrom)}
          />
          <input
            className={cn('form__input', { invalid: !valid })}
            type="number"
            name="to"
            onChange={this.onChange}
            value={to}
            {...attr}
            placeholder={i18next.t(keyMap.formsTo)}
          />
        </div>
      </InputFieldWrapper>
    );
  }
}

export default connectToContext(NumberRange);
